import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSignatureDetailsApi } from "../../../api/request/clients/clients";
import columns from "../../../columns/clients/signature/signature";
import SkeletonTable from "../../../components/table/SkeletonTable";
import SignatureAuditModal from "../../reports/components/SignatureAuditModal";
import Templates from "../../../assets/Templates";
import View from "../../../assets/View";
import GlobalTooltip from "../../../components/common/GlobalTooltip";

const Signature = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [signatureOpen, setSignatureOpen] = useState(false);
  const [selectedSign, setSelectedSign] = useState([]);

  const getSignatureData = async () => {
    try {
      setIsLoading(true);
      const { data } = await getSignatureDetailsApi({
        client_id: id,
        page: currentPage,
      });
      if (data?.status)
        setData(
          data?.data?.map((item) => ({
            ...item,
            fileNumber: item?.file?.file_number,
            fileName: item?.file?.service_name_slug,
            action: (
              <div className="flex gap-3 items-center">
                <GlobalTooltip title={"View Signature File"}>
                  <a
                    href={item?.path || "#"}
                    target={item?.path && "_blank"}
                    className="font-medium text-blue-500"
                  >
                    <View />
                  </a>
                </GlobalTooltip>
                <GlobalTooltip title={"View Signature Audit Report"}>
                  <div
                    onClick={() => {
                      setSelectedSign(item);
                      setSignatureOpen(true);
                    }}
                  >
                    <Templates />
                  </div>
                </GlobalTooltip>
              </div>
            ),
          }))
        );
      setTotal(data?.total_record);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) getSignatureData();
  }, [currentPage]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };

  return (
    <div className="bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className=" font-semibold text-2xl">
          Signatures {total ? `(${total})` : null}
        </p>
      </div>

      <div className="mt-5">
        <SkeletonTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>

      {/* Signature Audit Report */}
      <SignatureAuditModal
        isOpen={signatureOpen}
        setIsOpen={setSignatureOpen}
        selectedData={selectedSign}
      />
    </div>
  );
};

export default Signature;
